<template>
  <div class="card modal-card">
    <div class="modal-card-body pd-0">
      <header class="bandeau-modal card-header">
      </header>
      <div class="card-content">
        <div class="center">
          <div class="columns is-gapless">
            <div class="column mgt-20px">
              <h1 class="title is-size-3">
                {{ $t('ajoutDevis.table.editionIntervenant.title') }}
              </h1>
            </div>
          </div>
        </div>
        <error-msg-component :messages="messagesErreur"
                             class="mgt-20px"
                             :error="error"
                             :messagesChampsVide="messagesChampsVide"
                             :champsVide="champsVide"
                             :title="'general.problemOccurred'"
                             @close="error = $event"/>
        <div class="columns mgt-20px">
          <div class="column is-6">
            <b-field :label="$t('ajoutDevis.table.editionIntervenant.titreIntervenant')">
              <div class="columns is-marginless">
                <b-input class="column is-paddingless no-border-radius-right" v-model="titre">
                </b-input>
                <div class="control column is-narrow is-paddingless">
                  <button class="button is-primary" @click="defineTitreIntervenant">
                    <b-icon icon="autorenew"></b-icon>
                  </button>
                </div>
              </div>
            </b-field>
            <b-field class="obligatoire"
                     :label="$t('ajoutDevis.table.editionIntervenant.nomCommercial')">
              <b-input class="column is-paddingless" v-model="nomCommercial">
              </b-input>
            </b-field>
            <b-field
              v-if="intervenant.annonceur"
              :label="$t('ajoutDevis.table.editionIntervenant.applicationTva')">
              <b-select v-model="applicationTva" expanded>
                <option
                  v-for="item in constantes.LISTE_APPLICATION_TVA"
                  :value="item.code"
                  :key="item.code">
                  {{ $t(item.libelle) }}
                </option>
              </b-select>
            </b-field>
            <b-field :label="$t('ajoutDevis.table.editionIntervenant.siret')">
              <b-input v-model="siret"></b-input>
            </b-field>
            <b-field :label="$t('ajoutDevis.table.editionIntervenant.tvaIntracommunautaire')">
              <b-input v-model="tvaIntracommunautaire"></b-input>
            </b-field>
          </div>
          <div class="column is-6">
            <b-field v-if="adresse"
              :label="$t('ajoutDevis.table.editionIntervenant.adressePostal')">
              <adresse :adresse="adresse" :showLibelle="false" :showLibellePays="false"
                :showLibelleVille="false" :showLibelleCodePostal="false"
                :tableName="TIERS"></adresse>
            </b-field>
          </div>
        </div>
        <qd-checkbox v-model="miseAJourFicheClient" :class="{'mgl-10px' : intervenant.payeur}"
                    class="mgt-10px has-text-default mgl-10px">
          {{ $t('ajoutDevis.table.editionIntervenant.miseAjourFicheClient') }}
        </qd-checkbox>
        <footer>
          <b-field class="mgt-15px">
            <div class="is-pulled-left boutonAction">
              <a class="button" @click="$parent.close()">
                {{ $t('ajoutDevis.table.editionIntervenant.cancel')}}
              </a>
            </div>
            <div class="is-pulled-left boutonAction">
              <button
                :class="{ 'button-access-no-permission': !this.nomCommercial }"
                :disabled="!this.nomCommercial"
                class="button is-addOrEdit" @click="changeIntervenantInformation">
                {{ $t('ajoutDevis.table.editionIntervenant.add')}}
              </button>
            </div>
          </b-field>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import adresse from '@/components/general/adresse';
import defineTitreIntervenant from '@/services/devisCommandes/defineTitreIntervenant';
import { update, get } from '@/api/tiers';
import messageErreur from '@/services/general/messageErreur';
import { TIERS } from '@/configuration/ville/villeConf';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import validation from '@/services/tiers/validationTiers';
import validationGeneral from '@/services/validation/validation';
import champsTiersTranslator from '@/services/tiers/champsTiersTranslator';
import { LISTE_APPLICATION_TVA } from '@/configuration/tiers/tiersConf';

const societe = createNamespacedHelpers('societe');

export default {
  props: {
    intervenant: {
      type: Object,
      required: true,
      default: null,
    },
  },
  data() {
    return {
      TIERS: TIERS,
      adresse: null,
      titre: null,
      miseAJourFicheClient: false,
      error: false,
      messagesErreur: [],
      champsVide: [],
      messagesChampsVide: [],
      nomCommercial: null,
      applicationTva: null,
      constantes: {
        LISTE_APPLICATION_TVA,
      },
      siret: null,
      tvaIntracommunautaire: null,
    };
  },
  computed: {
    ...societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
  },
  components: {
    adresse,
    errorMsgComponent,
  },
  methods: {
    async updateTiersInfos() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.messagesErreur = [];
        this.error = false;
        this.messagesChampsVide = [];
        this.champsVide = [];
        const tiers = (await get(this.intervenant.tiersId)).data.result;
        tiers.adressePostale = this.adresse;
        tiers.applicationTva = this.applicationTva;
        tiers.nomCommercial = this.nomCommercial;
        tiers.siret = this.siret;
        tiers.tvaIntracommunautaire = this.tvaIntracommunautaire;
        await update(tiers);
        this.$emit('updateInt');
        this.$parent.close();
        loadingComponent.close();
      } catch (e) {
        if (e.response.data.error) {
          validationGeneral(this.$i18n, e.response, this.champsVide,
            this.messagesErreur, this.messagesChampsVide, champsTiersTranslator);
          validation(e.response, this.messagesErreur);
          this.error = true;
        } else messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
    defineTitreIntervenant() {
      const intervenantCopy = cloneDeep(this.intervenant);
      intervenantCopy.titre = null;
      defineTitreIntervenant(intervenantCopy, this.$i18n);
      this.titre = intervenantCopy.titre;
    },
    changeIntervenantInformation() {
      this.intervenant.adressePostale = this.adresse;
      this.intervenant.titre = this.titre;
      this.intervenant.applicationTva = this.applicationTva;
      this.intervenant.nomCommercial = this.nomCommercial;
      this.intervenant.siret = this.siret;
      this.intervenant.tvaIntracommunautaire = this.tvaIntracommunautaire;
      if (this.miseAJourFicheClient) this.updateTiersInfos();
      else {
        this.$emit('updateInt');
        this.$parent.close();
      }
    },
  },
  mounted() {
    this.adresse = cloneDeep(this.intervenant.adressePostale);
    this.titre = cloneDeep(this.intervenant.titre);
    this.nomCommercial = cloneDeep(this.intervenant.nomCommercial);
    this.applicationTva = cloneDeep(this.intervenant.applicationTva);
    this.siret = cloneDeep(this.intervenant.siret);
    this.tvaIntracommunautaire = cloneDeep(this.intervenant.tvaIntracommunautaire);
  },
};
</script>
